import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log('VVROS2JGbFlVbXhhUTBKcFpWTkNSVkY1ZDJkVVJrbG5TbWxDVDJJeVJtOU1hVUY1VFVSRk5VeFVRWGhNVkUxM1RHYzlQUT09')
reportWebVitals();
